
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import gestionXml from '../Actions/gestionXml';
import { downloadFile, getTaxPayer, validateVolume } from '../helpers';
import { ActivateSchedule, DesctivateSchedule, getFilesDownloadedRequest, getFilesDownloadedWithFilterRequest, generateDownloadRequest, getZipsFromFilePathRequest, getEfosRequestDataRequest, createEfosRequest, generateGetScheduleRequest, generateScheduleRequest, getLastEfosRequest, changePasswordRequest, searchScheduleRequest, updateScheduleConfigRequest, removeScheduleConfigRequest, exportScheduleConfigsRequest } from '../Api/Gestion';
import { startLoading, stopLoading } from '../LoadingHelper';
import schedule from '../Actions/schedule'
import GenerateRequestDownloadFilesProcess from '../ProcessClasses/GenerateRequestDownloadFilesProcess';
import GenerateRequestEfosProcess from '../ProcessClasses/GenerateRequestEfosProcess';
import { CATEGORY_GA, eventGA } from '../Helpers/GoogleAnalytics';
const { types } = gestionXml;
const { types: scheduleTypes } = schedule;
const { setDataDownloadFiles, setFilteredDownloadedFiles, updateDownloadsPagination, updateFilteredDownloadsPagination, setEfosRequestData, restartEfosState, setDownloadedFiles, setLastEfos } = gestionXml.actions;
const { getSchedule, setScheduleRecords, setPaginationSchedule, setScheduleStatus, searchSchedule } = schedule.actions
const downloadsPagination = state => state.gestionXml.downloadsPagination;
const schedulePagination = state => state.schedule.schedulePagination;
const scheduleFilters = state => state.schedule.scheduleFilters;
const gestionXmlStore = state => state.gestionXml;
const taxPayerVolumen = state => state.taxpayer.taxpayerVolume;

export function* getDownloadedFiled({ query }) {
    const loadingId = yield call(startLoading, 'tableLoading');
    try {
        if (query.requestType === undefined)
            query.requestType = -1;
        if (query.statusRequest === undefined)
            query.statusRequest = -1;
        const response = yield call(getFilesDownloadedRequest, query);
        if (response && response.status === 'success') {
            yield put(setDownloadedFiles(response.data != null ? response.data.records : []))
            yield put(updateDownloadsPagination(response.data.metaData));
        } else {
            message.error(response.messageDetail, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* getFilteredDownloadedFiles({ query }) {
    const loadingId = yield call(startLoading, 'tableLoading');
    try {
        const response = yield call(getFilesDownloadedWithFilterRequest, query);
        if (response && response.status === 'success') {
            yield put(setFilteredDownloadedFiles(response.data != null ? response.data.records : []))
            const data = {
                ...query,
                ...response.data.metaData
            };
            yield put(updateFilteredDownloadsPagination(response.data != null && data ));
        } else {
            message.error(response.messageDetail, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* generateRequestDownloadFiles({ data }) {
    const loadingId = yield call(startLoading);
    const query = yield select(downloadsPagination);
    try {
        if (data.generatePDF) {
            eventGA(CATEGORY_GA.downloads.downloadWithoutPdf);
        } else {
            eventGA(CATEGORY_GA.downloads.downloadWithPdf);
        }
        let process = new GenerateRequestDownloadFilesProcess(data);
        let result = process.getDataToSend();
        const response = yield call(generateDownloadRequest, result);
        if (response && response.status === 'success') {
            yield call(getDownloadedFiled, { query });
            yield put(setDataDownloadFiles({ startDate: '', endDate: '', rfcsToFilter: [] }))
            message.success('Solicitud enviada correctamente', 5);
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}
export function* generateGetSchedules({ query }) {
    const loadingId = yield call(startLoading);    
    try {
        const response = yield call(generateGetScheduleRequest, query);
        if (response && response.status === 'success') {
            yield put(setScheduleRecords(response.data.records))
            yield put(setPaginationSchedule(response.data.metaData))
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* generateSchedule({ payload }) {    
    
    
    const {processType, lapseDays, documentType} = payload
    const loadingId = yield call(startLoading);
    const queryConfig = yield select(schedulePagination);
    const taxpayerResult = yield select(taxPayerVolumen);
    payload.taxId.forEach(taxId =>{
        const volumeInfo =getTaxPayer(taxpayerResult,taxId);
        if(!validateVolume(volumeInfo,processType,lapseDays,documentType)){
            message.error(`En base a tu volumen mensual, no puedes programar esta descarga para el RFC ${taxId}.`, 5);
            return;
        }
    })
    
    try {
        
        const response = yield call(generateScheduleRequest, payload);
        if (response && response.status === 'success') {
            message.success('Rutina enviada correctamente', 5);
            yield put(getSchedule({
                ...queryConfig,
                page:1,
                perPage:5
            }))
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* searchSchedules({ query }) {
    const loadingId = yield call(startLoading, 'tableLoading');
    try {
        const filters = yield select(scheduleFilters);
        const response = yield call(searchScheduleRequest, { ...query, filters });
        if (response && response.status === 'success') {
            yield put(setScheduleRecords(response.data.records))
            yield put(setPaginationSchedule(response.data.metaData))
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* updateScheduleConfigSaga({ payload }) {
    const loadingId = yield call(startLoading);
    const queryConfig = yield select(schedulePagination);
    try {
        // A1: validar volumen mensual al cambiar el rango de días
        const taxpayerResult = yield select(taxPayerVolumen);
        const volumeInfo = getTaxPayer(taxpayerResult, payload.taxId);
        const lapseDays = payload.changes && payload.changes.lapseDays;
        if (volumeInfo && lapseDays && !validateVolume(volumeInfo, String(payload.processType), lapseDays, String(payload.documentType))) {
            message.error(`En base a tu volumen mensual, no puedes programar esta descarga para el RFC ${payload.taxId}.`, 5);
            return;
        }
        const response = yield call(updateScheduleConfigRequest, payload);
        if (response && response.status === 'success') {
            message.success('Registro actualizado correctamente', 5);
            yield put(searchSchedule({ page: queryConfig.page, perPage: queryConfig.perPage }));
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* removeScheduleConfigSaga({ payload }) {
    const loadingId = yield call(startLoading);
    const queryConfig = yield select(schedulePagination);
    try {
        const response = yield call(removeScheduleConfigRequest, payload);
        if (response && response.status === 'success') {
            message.success('Registro eliminado correctamente', 5);
            yield put(searchSchedule({ page: 1, perPage: queryConfig.perPage }));
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* exportScheduleConfigsSaga() {
    const loadingId = yield call(startLoading);
    try {
        const filters = yield select(scheduleFilters);
        const blob = yield call(exportScheduleConfigsRequest, filters);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
        link.href = url;
        link.download = `configuraciones_programadas_${timestamp}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
        message.success('Reporte generado correctamente', 5);
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* generateUpdateStatusSchedule( {data} ) {
    const loadingId = yield call(startLoading);
    let response = {}
    try {
        if (data.row.active===1) {
            response = yield call(ActivateSchedule, data.row);
        } else {
            response = yield call(DesctivateSchedule, data.row);
        }
        if (response && response.status === 'success') {
            yield put(setScheduleStatus(data))
            message.success('Estatus actualizado correctamente', 5);
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* getZipsFromFilePath({ filePath }) {
    const loadingId = yield call(startLoading);
    const response = yield call(getZipsFromFilePathRequest, filePath);
    try {
        if (response && response.status === 'success') {
            eventGA(CATEGORY_GA.downloads.downloadReporte);
            downloadFile(response.data);
        }
        else
            message.error(`${response.message}`, 5);
    } catch (error) {
        message.error(`${error.message}`, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

function* getEfosRequestData({ data }) {
    const loadingId = yield call(startLoading, 'efosTable');
    try {
        const response = yield call(getEfosRequestDataRequest, data);
        if (response && response.status === 'success') {
            yield put(setEfosRequestData(response.data != null ? response.data.records : []));
        } else {
            message.error(`${response.message}`, 5);
        }
    } catch (error) {
        message.error(`${error.message}`, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

function* createEfos({ data }) {
    const loadingId = yield call(startLoading);
    try {
        const gestionStore = yield select(gestionXmlStore);
        let process = new GenerateRequestEfosProcess(data, gestionStore.downloadXmls.taxId);
        let result = process.getDataToSend();
        const response = yield call(createEfosRequest, result);
        if (response && response.status === 'success') {
            eventGA(CATEGORY_GA.downloads.downloadWithEFOS);
            yield put(restartEfosState());
            yield call(getEfosRequestData, { data: {} });
            message.success('Solicitud enviada correctamente', 5);
        } else {
            message.error(`${response.message}`, 5);
        }
    } catch (error) {
        message.error(`${error.message}`, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

function* getLastEfos() {
    try {
        const response = yield call(getLastEfosRequest);
        if (response && response.status === 'success') {
            yield put(setLastEfos(response.data));
        } else {
            message.error(`${response.message}`, 5);
        }
    } catch (error) {
        message.error(`${error.message}`, 5);
    }
}

function* requestChangePassword({ data }) {
    const {username:email,token} = data;
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(changePasswordRequest, {email, token});        
        if (response && response.status === 'success') {
            message.success(`Se ha enviado un correo a la cuenta con instrucciones para reestablecer su contraseña`, 5);
        } else {
            message.error(`${response.message}`, 5);
        }
    } catch (error) {
        message.error(`${error.message}`, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* gestionSaga() {
    yield takeEvery(scheduleTypes.UPDATE_SCHEDULE_STATUS,generateUpdateStatusSchedule);
    yield takeEvery(scheduleTypes.SAVE_SCHEDULE, generateSchedule);
    yield takeEvery(scheduleTypes.GET_SCHEDULE, generateGetSchedules);
    // takeLatest: si llega una búsqueda nueva se cancela la anterior en vuelo,
    // evitando respuestas fuera de orden y trabajo innecesario.
    yield takeLatest(scheduleTypes.SEARCH_SCHEDULE, searchSchedules);
    yield takeEvery(scheduleTypes.UPDATE_SCHEDULE_CONFIG, updateScheduleConfigSaga);
    yield takeEvery(scheduleTypes.REMOVE_SCHEDULE_CONFIG, removeScheduleConfigSaga);
    yield takeEvery(scheduleTypes.EXPORT_SCHEDULE_CONFIGS, exportScheduleConfigsSaga);
    yield takeEvery(types.GET_DOWNLOADED_FILES, getDownloadedFiled);
    yield takeEvery(types.GET_FILTERED_DOWNLOADED_FILES, getFilteredDownloadedFiles);
    yield takeEvery(types.GENERATE_REQUEST_DOWNLOAD_FILES, generateRequestDownloadFiles);
    yield takeEvery(types.GET_ZIP_FROM_PATH, getZipsFromFilePath);
    yield takeEvery(types.GET_EFOS_REQUEST_DATA, getEfosRequestData);
    yield takeEvery(types.CREATE_EFOS_REQUEST, createEfos);
    yield takeEvery(types.GET_LAST_EFOS_REQUEST, getLastEfos);
    yield takeEvery(types.REQUEST_CHANGE_PASSWORD, requestChangePassword);
}